import React from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import '../App.css';

const NavBar = () => {
    return (

        <div className="mt-1">
            <Navbar className="navbar-dark bg-success text-center" collapseOnSelect expand="lg" variant="light">
                <Container>
                    <Navbar.Brand href="/"><h1>Modern</h1></Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link href="/Home" className="m-1"><h5>Home</h5></Nav.Link>
                            <Nav.Link href="/Gallery" className="m-1"><h5>Gallery</h5></Nav.Link>
                            <Nav.Link href="/Notifications" className="m-1"><h5>Notifications</h5></Nav.Link>
                            <h5> <NavDropdown className="m-1" title="Profile" id="collasible-nav-dropdown">
                                <NavDropdown.Item href="#action/3.1" className="m-1">Modern</NavDropdown.Item>
                                <NavDropdown.Item href="#action/3.2">
                                    View Profile
                                </NavDropdown.Item>
                                <NavDropdown.Item href="#action/3.3">Edit Profile</NavDropdown.Item>
                                <NavDropdown.Divider />
                                <NavDropdown.Item href="#action/3.4">
                                    Education
                                </NavDropdown.Item>
                            </NavDropdown></h5>
                        </Nav>
                        <Nav>
                            
                            <Nav.Link href="/Login" className="m-1"><h2>Login</h2></Nav.Link>
                            {/* <Nav.Link className="m-1" eventKey={2} href="#memes">
                                <h4>Downloads</h4>
                            </Nav.Link> */}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );

};
export default NavBar;